import { render, staticRenderFns } from "./CommentListForm.vue?vue&type=template&id=016c637e&scoped=true&"
import script from "./CommentListForm.vue?vue&type=script&lang=js&"
export * from "./CommentListForm.vue?vue&type=script&lang=js&"
import style0 from "./CommentListForm.vue?vue&type=style&index=0&id=016c637e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016c637e",
  null
  
)

export default component.exports